export default {
  index: [
    {
      path: '/teahome',
      component: resolve => require(['./tea_homeIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/cstorehome/_router.js